/**
 * convert the number of pixels to rem
 */
export function px(pixels: number) {
  return `${pixels / 16}rem`;
}
